import gql from 'graphql-tag'

export const mutation = gql`
  mutation deleteProjectionPayment($id: Int!) {
    record: delete_sales_projection_payment_by_pk(id: $id) {
      id
    }
  }
`

export default mutation
